<div
  class="message-container text-center px-2 cbsw-failed-booking-step"
  role="alert"
  [attr.aria-live]="'assertive'"
  [attr.aria-label]="'Booking failed notification'"
  [attr.aria-atomic]="true"
  [attr.aria-relevant]="'all'"
>
  <div
    class="mb-1"
    role="heading"
    aria-level="2"
    [attr.aria-label]="'Booking error'"
  >
    <app-csw-text
      [text]="'booking_components.errorTitle' | translate"
      customClass="fw-600"
    />
  </div>

  <div
    role="status"
    [attr.aria-live]="'polite'"
    [attr.aria-label]="'Error details'"
  >
    <app-csw-text
      [text]="errorMessage | translate"
      [attr.aria-label]="'Error message: ' + (errorMessage | translate)"
    />
  </div>

  @if (showRefundNotice) {
    <div class="alert alert-info mt-3" role="status">
      {{ 'payment_components.refundNotice' | translate: { transactionId: refundTransactionId } }}
    </div>
  }

  <div
    class="mt-4"
    role="navigation"
    [attr.aria-label]="'Booking failed actions'"
  >
    <app-button
      id="{{ 'booking-failed-addional-booking-btn' }}"
      (clickEvent)="onAddtionalBooking()"
      [fontColor]="widgetService?.widgetConf?.button_font_color"
      [backgroundColor]="widgetService?.widgetConf?.button_background_color"
      role="button"
      [attr.aria-label]="'Book another appointment'"
      [attr.aria-describedby]="'booking-failed-instructions'"
      tabindex="0"
    >
      {{ 'booking_components.bookAppointmentAgain' | translate }}
    </app-button>
    <div
      id="booking-failed-instructions"
      class="visually-hidden"
      role="status"
    >
      Click this button to start a new booking process
    </div>
  </div>
</div>
